import React from 'react'
import ListingAlgolia from 'components/ListingAlgolia'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import { CAS_DOMAIN } from 'utils'
import { useTrans } from 'hooks'

const NumeroRivistaRisorseTemplate = props => {
  const { numeroRivista, pagina, className = '' } = props

  const t = useTrans()

  const background = numeroRivista.preview_image
    ? {
        backgroundImage: `url(${CAS_DOMAIN}${numeroRivista.preview_image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        paddingBottom: '13rem!important', // accrocchio
      }
    : { backgroundColor: 'black', paddingBottom: '13rem!important' }

  const filtriDisponibili = [
    'visibilita', // custom
    'Ordine di scuola',
    'Classe',
    'Eta',
    'Disciplina',
    'Tema',
    'models', // custom
    'Tipo Strumento',
  ]

  return (
    <main className={`numero-rivista-risorse-template ${className ? ` ${className}` : ''}`}>
      <div className="w-container-fluid u-before-section u-background-image" style={background}>
        <div className="w-container">
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        </div>
        <section className="listing-page__header numero-rivista-risorse-template__header">
          <div className="w-container">
            <h2 className="numero-rivista-risorse-template__title">{numeroRivista.titolo}</h2>
            <h1 className="numero-rivista-risorse-template__subtitle">
              {t('Lezioni e materiali')}
            </h1>
          </div>
        </section>
      </div>
      <section className="listing-page__list-section section">
        <ListingAlgolia
          numeroRivista={numeroRivista.id}
          filtriDisponibili={filtriDisponibili}
          className="numero-rivista-risorse-template__listing"
        />
      </section>
    </main>
  )
}

export default NumeroRivistaRisorseTemplate
